import React from 'react'
import PropTypes from 'prop-types'
import { brandConfig } from '../../../config/brandConfig'

export const BankAccountStatusIcon = ({ active }) => {
  const color = active
    ? brandConfig.colors.accentColors.primary.main
    : brandConfig.colors.defaultColors.orange['450']
  return (
    <svg
      width="71"
      height="40"
      viewBox="0 0 71 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill={color} />
      <path
        d="M18.3839 24.7831L13.3635 19.7627L11.9493 21.1769L16.9697 26.1973L18.3839 24.7831Z"
        fill="black"
      />
      <path
        d="M17.0051 26.2168L28.0359 15.186L26.6217 13.7718L15.5909 24.8026L17.0051 26.2168Z"
        fill="black"
      />
      <rect x="31" width="40" height="40" rx="20" fill="#EEEEEE" />
      <path
        d="M60.58 17.7475L51.47 11.1875C51.12 10.9375 50.64 10.9375 50.29 11.1875L41.41 17.7475C41.1 17.9775 40.97 18.3575 41.03 18.7275C41.03 18.7775 41 18.8175 41 18.8675V28.9975H61V18.8675C61 18.8675 60.98 18.7775 60.97 18.7275C61.04 18.3575 60.9 17.9675 60.58 17.7375V17.7475ZM50.89 13.2375L56.89 17.5575H45.04L50.89 13.2375ZM52.8 19.5575V26.9975H48.95V19.5575H52.8ZM43 19.5575H46.95V26.9975H43V19.5575ZM54.8 26.9975V19.5575H59V26.9975H54.8Z"
        fill="black"
      />
    </svg>
  )
}

BankAccountStatusIcon.propTypes = {
  active: PropTypes.bool,
}
